import React from "react";
import ImageWithHotspot from "./ImageWithHotspot";
import * as modalStyles from "../UI/ImageModal/ImageModal.module.scss";
import usePopupImage from "../BowerModal/usePopupImage";
const KitchenImageWithHotspot = (props) => {
  let { images, onHotspotClick } = props;
  return (
    <ImageWithHotspot
      heading="Kitchen"
      subheading="7.7% of household plastic waste"
      onHotspotClick={onHotspotClick}
      images={images}
      imageName="kitchen_01"
      hoverImageName="kitchen_01_hover"
      hotspots={[
        {
          popupImages: usePopupImage(images, "green", "kitchen_sink"),
          imageName: "kitchen_02",
          mobileImageName: "mobile_kitchen_cleaning_products",
          x: 77.2,
          y: 63.2,
          averageWaste: "3.4 kg.",

          tooltipBackground: "",
          popupTableData: {
            "Dish Brush": "0.20 kg.",
            "Hand Lotion": "0.60 kg.",
            "Hand Wash": "0.77 kg.",
            Scourer: "0.04 kg.",
            "Washing Up Liquid": "0.43 kg.",
            "Kitchen Cleaner Spray": "0.84 kg.",
            "Degrease Oven Spray": "0.28 kg.",
            "Rinse Aid": "0.24 kg.",
          },

          popupContent: {
            heading: "Kitchen Sink",
            p1: "Most of us have adopted the good habit of recycling plastic packaging from our food, but besides the fridge, the cabinet beneath the kitchen sink is often crammed with plastic. Cleaning products under the kitchen sink account for 30% of all single-use plastic waste produced in the Kitchen. Kitchen Cleaner alone is responsible for 23% of kitchen plastic waste. Now that’s some food for thought.",
          },
        },
        {
          popupImages: usePopupImage(images, "green", "kitchen_drawer"),

          imageName: "kitchen_03",
          mobileImageName: "mobile_kitchen_drawer",
          x: 64.4,
          y: 78.3,
          tooltipBackground: "",
          tooltipTitle: "Title",
          averageWaste: "0.33 kg.",
          tooltipContent: "",
          popupTableData: {
            "Bin Bags": "0.8 kg.",
            "Kitchen Roll (packaging)": "0.12 kg.",
            "Dishwasher Tablets": "0.13 kg.",
          },
          popupContent: {
            heading: "Kitchen Drawer",
            p1: "Where do we put all of our single-use plastic waste? In a single-use plastic bin bag. Bin bags account for 24% of plastic waste found in the kitchen drawer. Because they are used more frequently, dishwasher tablets and kitchen roll packaging contribute a higher amount (40% and 37% respectively).",
            p2: "Dishwasher tablets are often wrapped in PET plastic. The collection, separation and reprocessing of household plastic film is not widely implemented in the UK, generating significant waste.",
          },
        },
      ]}
    />
  );
};

export default KitchenImageWithHotspot;
